import * as React from "react";
const SvgDot = props => <svg xmlns="http://www.w3.org/2000/svg" width={4} height={4} fill="none" viewBox="0 0 4 4" {...props}><circle cx={2} cy={2} r={1.5} fill="#131432" stroke="#131432" /></svg>;
export { SvgDot as ReactComponent };